import { makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { initTrialNotice } from '@shared/services/trial-notice/trial-notice.service';

export function provideTrialNotice() {
  return makeEnvironmentProviders([provideEnvironmentInitializer(() => initTrialNotice())]);
}
